import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Spinner } from 'dibs-elements/exports/Spinner';

import styles from './NftSecondaryMarketToasts.scss';

export const NftSecondaryMarketLoadingToast: FC = () => {
    return (
        <div className={styles.toastWrapper}>
            <div className={styles.toastHeader}>
                <Spinner size="tiny" black />

                <strong className={styles.toastHeaderText}>
                    <FormattedMessage
                        id="nft.secondaryMarket.toast.loading.processingTransaction.title"
                        defaultMessage="Processing the transaction"
                    />
                </strong>
            </div>

            <FormattedMessage
                id="nft.secondaryMarket.toast.loading.processingTransaction.text"
                defaultMessage="Depending on your gas fees, this could take up to a few minutes."
            />
        </div>
    );
};
